module.exports = __webpack_public_path__ + "static/media/Banner-ebit.42b357db.42b357db.png";